function t(n) {
  return typeof n == "string";
}
export {
  t as isString
};
